<template>
    <!-- Navbar dropdowns -->
    <b-nav-item-dropdown text="SAP Web" v-show="isOK == true" left>
        <b-dropdown-item exact to="/home/datosrci">Datos RCI</b-dropdown-item>
        <b-dropdown-item exact to="/home/datosregio">Datos Regio Color</b-dropdown-item>
    </b-nav-item-dropdown>
</template>

<script>
    import {mapState,mapActions} from 'vuex'
    import customMixin from '@/mixins/customMixin'
    export default {
        mixins : [customMixin],
        data: function(){
            return {
                isOK: false
            }
        },
        mounted(){
            this.init()
        },
        computed:{
            ...mapState('login',['rol_id']),
            ...mapState('permiso',['permiso']), 
        },
        methods:{
            ...mapActions({
                _fetchPermisos: 'permiso/fetchPermisosUsuarios',
            }),
            init(){
                this._fetchPermisos(this.rol_id).then(() => {  
                    //this.isOK =  this.isRCI(this.permiso) // queda obsoleto por los nuevos requierimientos
                    if (this.isSapWeb(this.permiso) == true || this.isSapWebVendedor(this.permiso) == true || this.isSapWebAdmin(this.permiso) == true) {
                        this.isOK = true
                    } 
         
                })
            },
        }//end methods          
    }
</script>

<style lang="scss" scoped>

</style>